import { IconButton, IconButtonProps, styled } from "@mui/material";
import hexToRgba from "hex-to-rgba";

interface IconButtonPaperProps extends IconButtonProps {
  outlinedCustom?: boolean;
  hasBorder?: boolean;
}

export function IconButtonPaper({ outlinedCustom, hasBorder, ...props }: IconButtonPaperProps) {
  const IconButtonPaper = styled((props: IconButtonProps) => <IconButton {...props} />)(
    ({ theme }) => ({
      backgroundColor: outlinedCustom ? "transparent" : theme.palette.secondary.main + "!important",
      border: hasBorder ? `1px solid ${hexToRgba("#fff", 0.5)} !important` : "none",
      width: 40,
      height: 40,
      borderRadius: 12,
      "&.Mui-disabled": {
        opacity: 0.6,
      },
    })
  );

  return <IconButtonPaper {...props} />;
}
